<template>
  <div class="media-popup">
    <div class="media-popup__container">
      <button @click.prevent="$emit('close')" class="btn btn__close"></button>
      <h1 class="media-popup__title">Media Manager</h1>
      <image-viewer :name="name"></image-viewer>
    </div>
  </div>
</template>

<script>
import imageViewer from './browser.vue'
export default{
  props: {
    name: {
      type: String,
      required: false,
      default: function () {
        return 'image'
      }
    }
  },
  components: {imageViewer},
  data: function () {
    return {
      image: null
    }
  },
  mounted: function () {
    window.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    })
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_media.popup"
</style>



// WEBPACK FOOTER //
// src/components/media/popup.vue